import { filterOptions } from "@src/helpers/constants";
import { Form, Select } from "antd";
import React from "react";

const SubjectGender: React.FC = () => {

  
  return (
    <Form.Item
      name="gender"
      label="Gender"
      rules={[
        {
          required: true,
          message: "Please select the gender",
        },
      ]}
    >
      <Select placeholder="" options={filterOptions?.gender} />
    </Form.Item>
  );
};

export default SubjectGender;
